import * as actions from "./Auth.actions";
import reducer from "./Auth.reducer";
import * as types from "./Auth.types";

const Entity = {
  actions, reducer, types,
};

export default Entity;
